import config from "./config"
import messages from './messages'

const postQuery = async (query = '', stage = "staging") => {
	const url = stage === "production" ? "https://api.signman.jp/v2" : "https://stg-api.signman.jp/v2"
	console.log('lib.postQuery', {
		url,
		query,
	})
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			query,
		}),
		mode: 'cors',
	})
		.then(r => r.json())
		.catch(e => {
			if (e.response) return e.response.data
			return {
				error: true,
				message: e.message,
			}
		})

	console.log('lib.postQuery:response', res)

	return res
}

export default {
	config,
	postQuery,
	messages
}
